import Link from "next/link";
import * as React from "react";
import { Article } from "@/types/index";
import styles from "./styles.module.css";

const RelatedArticles: React.FC<{
	title: string;
	articles: Array<Article>;
}> = ({ title, articles }) => {
	const listItems = articles.map((article) => {
		return (
			<li key={article.sys.id}>
				<Link href={`/broadband/guides/${article.fields.slug}`}>
					{article.fields.title}
				</Link>
			</li>
		);
	});

	return (
		<div className={styles.article__panel}>
			<div className={styles.panel__title}>
				<h3>{title}</h3>
			</div>
			<ul>{listItems}</ul>
		</div>
	);
};

export default RelatedArticles;
